import React from 'react';
import { createRoot } from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import ToastContainerProps from './utils/toastContainerProps';
import './theme/main.scss';
import App from './App';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <>
    <ToastContainer {...ToastContainerProps} />
    <App />
  </>
);
